import React, { Component } from "react";
import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import AsyncSelect from "react-select/async";
// import partyImage from '../../../public/images/dashboard-images/partyLogo.svg'

// datatable related plugins
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";

import { withTranslation } from "react-i18next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import { baseUrl, getPartyApi } from "api";
import "./datatables.scss";
// import parties from "assets/images/parties";

// Table data

class PartyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      sizePerPage: 10,
      totalSize: 10,
      parties: [],
    };
  }

  componentDidMount() {
    this.getPartyList();
  }

  async getPartyList(inputValue) {
    const data = await getPartyApi({
      page: this.state.page,
      limit: this.state.sizePerPage,
      name: inputValue,
    });
    if(data && data.data){
      this.setState(
        {
          totalSize: data.data.count,
          parties: data.data.parties,
        },
      );
    }
    
    if (Array.isArray(data.data.parties))
      return [{label: "All", value: ""}, ...data.data.parties.map(x => {
        return { label: x.name, value: x.id };
      })]
    else return [];
  }

  render() {
    const promiseOptions = inputValue =>
      new Promise(resolve => {
        setTimeout(() => {
          resolve(this.getPartyList(inputValue));
        }, 0);
      });
    const columns = [
      {
        dataField: "id",
        text: "#",
        sort: true,
      },
      {
        dataField: "name",
        text: `${this.props.t("Party Name")}`,
        sort: true,
        formatter: (cell, row) => (
          <>
            <div className="d-flex flex-row">
              <div>
                {row.logo == null || row.logo == "null" ? (
                  <img
                    src="images/dashboard-images/company.png"
                    className="width-50"
                  />
                ) : (
                  <img
                    src={`${baseUrl}/uploads/${row.logo}`}
                    className="width-50 rounded-circle"
                  />
                )}
              </div>
              <div className="ps-2">
                <span className="fw-bold fs-5"> {row.name} </span> <br />
                {row.shortName}
              </div>
            </div>
          </>
        ),
      },
      {
        dataField: "since",
        text: "Since",
        sort: true,
      },
      {
        dataField: "city",
        text: "City",
      },
      {
        dataField: "mobileNo1",
        text: `${this.props.t("Mobile no.1")}`,
      },
      {
        dataField: "mobileNo2",
        text: "Mobile no.2",
      },
      {
        dataField: "email",
        text: "Email ID",
      },
      {
        dataField: "viewdetails",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => (
          <div className="btn-group">
            <Link
              to={{
                pathname: "/add-party",
                query: { isEdit: true, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded">
                <img src="images/dashboard-images/edit.svg" />
              </button>
            </Link>
            <Link
              to={{
                pathname: "/add-party",
                query: { isView: true, data: row },
              }}
            >
              <button className="py-2 px-2 border-0 rounded ms-2">
                <img src="images/dashboard-images/view.svg" />
              </button>
            </Link>
          </div>
        ),
      },
    ];

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    const pageOptions = {
      paginationSize: 5,
      pageStartIndex: 1,
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      onPageChange: (page, limit) => {
        this.setState({ page: page }, () => this.getPartyList());
      },
      sizePerPageOptionRenderer: ({ text, page, onSizePerPageChange }) => {
        return (
          <li key={text} role="presentation" className="dropdown-item">
            <a
              href="#"
              className="text-dark"
              tabIndex="-1"
              role="menuitem"
              data-page={page}
              onMouseDown={e => {
                onSizePerPageChange(page);
                this.setState({ page: 1, sizePerPage: page }, () =>
                  this.getPartyList()
                );
              }}
            >
              {text}
            </a>
          </li>
        );
      },
      sizePerPageList: [10, 25, 50, 100],
      page: this.state.page,
      totalSize: this.state.totalSize, // replace later with size(customers),
      custom: true,
    };

    const { SearchBar } = Search;

    //meta title
    document.title = "Manage Party";

    return (
      <PaginationProvider
        pagination={paginationFactory(pageOptions)}
        keyField="id"
        columns={columns}
        data={this.state.parties}
      >
        {({ paginationProps, paginationTableProps }) => (
          <ToolkitProvider
            keyField="id"
            columns={columns}
            data={this.state.parties}
            search
          >
            {toolkitProps => (
              <React.Fragment>
                <div className="page-content">
                  <div className="container-fluid">
                    <h3 className="text-black fw-bold text-uppercase">
                      {this.props.t("Party List")}
                    </h3>
                    <Row>
                      <Col md="6" sm="12">
                        <div className="pt-4">
                          <p className="d-inline pe-3 fs-5">
                            {this.props.t("Show")}
                          </p>
                          <div className="d-inline">
                            <SizePerPageDropdownStandalone
                              className=""
                              {...paginationProps}
                            />
                          </div>

                          <p className="d-inline ps-3 fs-5">
                            {this.props.t("entries")}
                          </p>
                        </div>
                      </Col>
                      <Col
                        xxl={{ offset: "3", size: "3" }}
                        xl={{ offset: "2", size: "4" }}
                        md={{ offset: "0", size: "6" }}
                        sm={{ offset: "0", size: "12" }}
                        className="text-start text-lg-end pt-4 pt-lg-0"
                      >
                        <div className="d-flex justify-content-end">
                          <div className="">
                            <label
                              htmlFor="search"
                              className="pt-2 fs-5 pe-1 text-end pe-lg-3 d-inline"
                            >{this.props.t("Search")}</label>
                          </div>
                          <AsyncSelect
                            onChange={e => {
                              if (e.value == "") {
                                this.getPartyList(null);
                              } else {

                              this.getPartyList(e.label);
                              }
                            }}
                            
                            loadOptions={promiseOptions}
                            defaultOptions={[{label: "All", value: ""}, ...this.state.parties.map(x => {
                              return { label: x.name, value: x.id };
                            })]}
                            className="border-gray"
                          />
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="col-12 mt-3">
                        <Card>
                          <CardBody>
                            <CardTitle className="h4">
                              {this.props.t("Party List")}
                            </CardTitle>

                            <React.Fragment>
                              <Row className="align-items-md-center mt-30">
                                <Col className="inner-custom-pagination d-flex"></Col>
                              </Row>
                              <Row className="mb-2"></Row>

                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      remote={true}
                                      keyField={"id"}
                                      responsive
                                      bordered={false}
                                      onTableChange={() => false}
                                      striped={false}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap"
                                      }
                                      headerWrapperClasses={"thead-light"}
                                      {...toolkitProps.baseProps}
                                      {...paginationTableProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Col className="inner-custom-pagination mt-4 d-flex justify-content-between">
                                <div className="">
                                  <h5>
                                    {this.props.t("Showing")}{" "}
                                    {(this.state.page - 1) *
                                      this.state.sizePerPage +
                                      1}{" "}
                                    -{" "}
                                    {this.state.totalSize <
                                    this.state.sizePerPage
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                          this.state.page >=
                                        this.state.totalSize
                                      ? this.state.totalSize
                                      : this.state.sizePerPage *
                                        this.state.page}{" "}
                                    of {this.state.totalSize}
                                  </h5>
                                </div>
                                <div className="ms-auto">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col>
                            </React.Fragment>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    );
  }
}
export default withTranslation()(PartyList);
